import {
  SizeGuideSection 
} from "../size-guide-section"

// src/components/size-guide-new/women/wader.tsx
const waderTableData = {
  headers: [
    [
      {
        content: "Neoprene Waders",
        colSpan: 6
      }
    ],
    [
      {
        content: "Wader Size"
      },
      {
        content: "Shoes Size"
      },
      {
        content: "Total Length(In)"
      },
      {
        content: "Inseam(In)"
      },
      {
        content: "Chest(In)"
      },
      {
        content: "Hip(In)"
      }
    ]
  ],
  data: [
    [
      {
        content: "5" 
      },
      {
        content: "5" 
      },
      {
        content: "53.9" 
      },
      {
        content: "32.1" 
      },
      {
        content: "30.7" 
      },
      {
        content: "29.7" 
      }
    ],
    [
      {
        content: "6" 
      },
      {
        content: "6" 
      },
      {
        content: "54.7" 
      },
      {
        content: "32.5" 
      },
      {
        content: "31.1" 
      },
      {
        content: "30.1" 
      }
    ],
    [
      {
        content: "7" 
      },
      {
        content: "7" 
      },
      {
        content: "55.3" 
      },
      {
        content: "32.9" 
      },
      {
        content: "31.7" 
      },
      {
        content: "30.7" 
      }
    ],
    [
      {
        content: "8" 
      },
      {
        content: "8" 
      },
      {
        content: "56.3" 
      },
      {
        content: "33.3" 
      },
      {
        content: "32.5" 
      },
      {
        content: "31.3" 
      }
    ],
    [
      {
        content: "9" 
      },
      {
        content: "9" 
      },
      {
        content: "56.9" 
      },
      {
        content: "33.7" 
      },
      {
        content: "32.9" 
      },
      {
        content: "31.7" 
      }
    ],
    [
      {
        content: "10" 
      },
      {
        content: "10" 
      },
      {
        content: "57.9" 
      },
      {
        content: "33.9" 
      },
      {
        content: "33.6" 
      },
      {
        content: "32.1" 
      }
    ]
  ]
}

export const WomenWader = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='Neoprene Waders'
    tableData={waderTableData}
    className={className} 
  />
}
